import React from 'react';
import { Step } from 'components/SteppedModal';
import useSocialShareModalFooter from 'containers/SocialShareModal/SocialShareModalFooter';
import { YouTubeSocialShareStep } from '../../types';
import YouTubeComposerStep, {
  YouTubeComposerStepProps,
} from './YouTubeComposerStep';

export type UseYouTubeComposerStepProps = YouTubeComposerStepProps & {
  onShare: () => void;
};

export default function useYouTubeComposerStep({
  title,
  selectedPlaylistsIds,
  onTitleChange,
  onPlaylistChange,
  onShare,
}: UseYouTubeComposerStepProps): Step<YouTubeSocialShareStep> {
  const footerConfig = useSocialShareModalFooter({
    onShare,
  });

  return {
    ...footerConfig,
    id: 'composer',
    component: (
      <YouTubeComposerStep
        {...{
          title,
          selectedPlaylistsIds,
          onTitleChange,
          onPlaylistChange,
        }}
      />
    ),
  };
}
